module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464175"
    }
  }, [_vm._v("Investindo no Amor Sinopse")])]), _c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464175"
    }
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])])]), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464175"
    }
  }, [_c('img', {
    staticClass: "section-break-symbol",
    attrs: {
      "alt": "image",
      "height": "101",
      "src": "d2d_images/image010.jpg",
      "width": "273"
    }
  })])]), _c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464175"
    }
  }, [_c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-d"
  }, [_vm._v("D")]), _vm._v("a autora best seller")]), _vm._v(" do USA Today, Lexy Timms.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Ame como se você nunca estivesse contando o custo.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kirk Sterling não via Bethany Walker desde que deu o fora nela. Ele havia terminado com ela para protegê-la de sua poderosa família, mas não a superou. Quando Bethany aparece, desesperada por sua ajuda, Kirk concorda, pronto para resistir ao seu charme sedutor.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Após seu rompimento com Kirk, Bethany Walker manteve distância, trabalhando duro para superar sua mágoa. Mas ela descobre que seu pai está em perigo e Kirk é o único homem a quem ela pode recorrer para pedir ajuda. Ver Kirk novamente ameaça reacender a rixa entre suas famílias; o pior de tudo, é que coloca em perigo seu coração sofrido. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Trabalhar junto é o desafio mais difícil que qualquer um dos dois já enfrentou. À medida que descobrem os segredos do passado e se aproximam da verdade chocante, o perigo espreita a cada esquina. Será que Kirk e Bethany reavivarão seu relacionamento ou a guerra entre suas famílias consumirá os dois? ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  })]), _c('ul', {
    staticStyle: {
      "font-size": "x-large",
      "text-align": "justify"
    }
  }, [_c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464175"
    }
  }), _c('li', [_c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464175"
    }
  }), _c('a', {
    attrs: {
      "id": "__RefHeading__57_1239064642"
    }
  }, [_vm._v("Conteúdo")])])]), _c('a', {
    attrs: {
      "id": "__RefHeading__57_1239064642"
    }
  }), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "__RefHeading__57_1239064642"
    }
  }), _c('a', {
    attrs: {
      "href": "#/c004#__RefHeading___Toc525464173"
    }
  }, [_vm._v("Série Banqueiro Bilionário"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("......................")]), _vm._v("3")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c005#__RefHeading___Toc525464174"
    }
  }, [_vm._v("Encontre Lexy Timms:"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v(".........................")]), _vm._v("4")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c006#__RefHeading___Toc525464175"
    }
  }, [_vm._v("Investindo no Amor Sinopse"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v(".....................")]), _vm._v("6")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c006#__RefHeading__57_1239064642"
    }
  }, [_vm._v("Conteúdo"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("....................................")]), _vm._v("8")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c007#__RefHeading___Toc525464176"
    }
  }, [_vm._v("Capítulo 1"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("..................................")]), _vm._v("10")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c008#__RefHeading___Toc525464177"
    }
  }, [_vm._v("Capítulo 2"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("..................................")]), _vm._v("20")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c009#__RefHeading___Toc525464178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capítulo 3"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("..................................")]), _vm._v("37")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c010#__RefHeading___Toc525464179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capítulo 4"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("..................................")]), _vm._v("54")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c011#__RefHeading___Toc525464180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capítulo 5"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("..................................")]), _vm._v("68")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c012#__RefHeading___Toc525464181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capítulo 6"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("..................................")]), _vm._v("81")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c013#__RefHeading___Toc525464182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capítulo 7"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("..................................")]), _vm._v("95")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c014#__RefHeading___Toc525464183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capítulo 8"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v(".................................")]), _vm._v("110")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c015#__RefHeading___Toc525464184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capítulo 9"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v(".................................")]), _vm._v("128")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c016#__RefHeading___Toc525464185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capítulo 10"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("................................")]), _vm._v("143")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c017#__RefHeading___Toc525464186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capítulo 11"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("................................")]), _vm._v("157")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c018#__RefHeading___Toc525464187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capítulo 12"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("................................")]), _vm._v("174")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c019#__RefHeading___Toc525464188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capítulo 13"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("................................")]), _vm._v("189")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c020#__RefHeading___Toc525464189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capítulo 14"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("................................")]), _vm._v("198")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c021#__RefHeading___Toc525464190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capítulo 15"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("................................")]), _vm._v("215")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c022#__RefHeading___Toc525464191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Série Banqueiro Bilionário"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("....................")]), _vm._v("227")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c023#__RefHeading__59_1239064642",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conhecendo Seu Valor Sinopse"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("................")]), _vm._v("228")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c024#__RefHeading___Toc525464194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LEITURAS GRATUITAS?"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("...................")]), _vm._v("231")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c025#__RefHeading___Toc525464195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mais por Timms:"), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("............................")]), _vm._v("232")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26644936","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c006.vue
// module id = 75
// module chunks = 0